import {useMutation} from '@tanstack/react-query'
import {useApplyOfferCodeApiMethod} from 'api/useApplyOfferCodeApiMethod'
import {useApplyVoucherCodeApiMethod} from 'api/useApplyVoucherCodeApiMethod'
import {useGetOrderApiMethod} from 'api/useGetOrderApiMethod'
import {Params} from 'types'

export const useApplyDiscountCodeMutation = () => {
  const getOrder = useGetOrderApiMethod()
  const applyOfferCode = useApplyOfferCodeApiMethod()
  const applyVoucherCode = useApplyVoucherCodeApiMethod()

  return useMutation({
    mutationFn: async ({order, code}: Params.ApplyDiscountCode) => {
      try {
        return await applyVoucherCode({order, code})
      } catch (offerError) {
        try {
          await applyOfferCode({order, code})
          return await getOrder(order.id)
        } catch (giftError) {
          throw new Error(`Can't apply the promo/gift code`)
        }
      }
    },
    meta: {
      silent: true,
    },
  })
}
